import styled from 'styled-components';
import { motion } from 'framer-motion';

export const PostWrapper = styled.div`
  max-width: 1000px;
  margin: 4rem auto;
  padding: 0 2rem;
  direction: rtl;
`;

export const PostHeader = styled.header`
  text-align: center;
  margin-bottom: 4rem;
`;

export const PostCategory = styled.span`
  background: ${props => props.theme.colors.secondaryLight || 'rgba(139, 115, 85, 0.1)'};
  color: ${props => props.theme.colors.brown};
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 1.5rem;
  display: inline-block;
`;

export const PostTitle = styled.h1`
  font-size: clamp(2rem, 5vw, 3.5rem);
  color: ${props => props.theme.colors.darkGreen};
  line-height: 1.2;
  margin-bottom: 1.5rem;
`;

export const PostMeta = styled.div`
  display: flex;
  justify-content: center;
  gap: 2rem;
  color: ${props => props.theme.colors.gray};
  font-size: 1rem;
`;

export const PostHeroImage = styled.div`
  width: 100%;
  height: 500px;
  background-image: url(${props => props.src});
  background-size: cover;
  background-position: center;
  border-radius: 30px;
  margin-bottom: 4rem;
  box-shadow: ${props => props.theme.shadows.large};

  @media (max-width: 768px) {
    height: 300px;
  }
`;

export const PostContent = styled.div`
  font-size: 1.2rem;
  line-height: 1.8;
  color: ${props => props.theme.colors.text};
  
  h2 {
    color: ${props => props.theme.colors.darkGreen};
    margin: 3rem 0 1.5rem;
    font-size: 2rem;
  }

  h3 {
    color: ${props => props.theme.colors.darkGreen};
    margin: 2rem 0 1rem;
    font-size: 1.5rem;
  }

  p {
    margin-bottom: 1.5rem;
  }

  ol, ul {
    margin-bottom: 1.5rem;
    padding-right: 2rem;
  }

  li {
    margin-bottom: 0.5rem;
  }
`;

export const ShareSection = styled.div`
  margin: 5rem 0;
  padding: 3rem;
  background: ${props => props.theme.colors.lightGray};
  border-radius: 20px;
  text-align: center;
`;

export const ShareTitle = styled.h3`
  margin-bottom: 2rem;
  color: ${props => props.theme.colors.darkGreen};
`;

export const ShareButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1.5rem;
`;

export const ShareButton = styled.a`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: ${props => props.bg || props.theme.colors.darkGreen};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  transition: all 0.3s ease;
  text-decoration: none;

  &:hover {
    transform: translateY(-5px);
    opacity: 0.9;
  }
`;

export const RelatedPostsSection = styled.section`
  margin-top: 6rem;
  padding-top: 4rem;
  border-top: 1px solid ${props => props.theme.colors.border};
`;

export const RelatedTitle = styled.h2`
  margin-bottom: 3rem;
  color: ${props => props.theme.colors.darkGreen};
  text-align: center;
`;

export const RelatedGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
`;

